import {createSlice} from "@reduxjs/toolkit"; 
import {getMonthObject} from './dateHelper'
const initialFilter = {
    filter:{
    month:getMonthObject(), // ⬅️ store both
    limit: 10,
    page: 1,
    }
}

const auditSlice = createSlice ({
    name:'audit',
    initialState:{
      auditScreenStatus: false,
      filter: initialFilter,
    },
    reducers:{
        toggleAudit:(state)=>{
          state.auditScreenStatus = !state.auditScreenStatus
        },
        setAudit:(state,action)=>{
         state.auditScreenStatus =  action.payload;
        },
        setMonth:(state,action)=>{
         state.filter.filter.month = action.payload;    
        },
        setPage:(state,action)=>{
         state.filter.filter.page = action.payload
        },
        setlimit:(state,action)=>{
        state.filter.filter.limit = action.payload
        },
        resetFilter:(state)=>{
         state.filter.filter ={...initialFilter.filter}
        }
   },     
});

export const {toggleAudit,setAudit,resetFilter,setMonth,setPage,setlimit} = auditSlice.actions;
export default auditSlice.reducer;